// extracted by mini-css-extract-plugin
export default {"card":"tzQRSTWq","image":"mRyLzFal","mobile":"mobile","icon":"AYzgeJv9","announce":"poAXEiNy"};